import { z } from 'zod'

// The concierge promise: up to three offers per request (BUSINESS_CASE.md section 3).
export const MAX_OFFERS = 3

export const requestOfferStatuses = ['proposed', 'sent', 'accepted', 'declined', 'expired'] as const
export type RequestOfferStatus = (typeof requestOfferStatuses)[number]

export const requestOfferStatusLabels: Record<RequestOfferStatus, string> = {
  proposed: 'Entwurf',
  sent: 'Wartet auf Antwort',
  accepted: 'Angenommen',
  declined: 'Abgelehnt',
  expired: 'Abgelaufen',
}

export const requestOfferStatusTones: Record<
  RequestOfferStatus,
  'info' | 'warning' | 'success' | 'danger' | 'neutral'
> = {
  proposed: 'neutral',
  sent: 'warning',
  accepted: 'success',
  declined: 'neutral',
  expired: 'neutral',
}

// a path segment or a hidden form field is user input like any other
export const idSchema = z.uuid()

/** One line of the founder's offer composer. The ensemble id is re-checked against the database. */
export const offerDraft = z.object({
  ensembleId: z.uuid(),
  priceEuro: z.coerce
    .number({ message: 'Bitte gib einen Preis in Euro an.' })
    .int('Bitte einen ganzen Euro-Betrag.')
    .min(100, 'Der Preis liegt unter 100 €.')
    .max(1_000_000),
  includesText: z.string().trim().max(1000).optional().or(z.literal('')),
})
export type OfferDraft = z.infer<typeof offerDraft>

export const offerDrafts = z
  .array(offerDraft)
  .min(1, 'Wähle mindestens ein Ensemble aus.')
  .max(MAX_OFFERS, `Höchstens ${MAX_OFFERS} Angebote pro Anfrage.`)

/** The booker's answer on the status page. */
export const offerResponse = z.object({
  offerId: z.uuid(),
  decision: z.enum(['accept', 'decline']),
})
export type OfferResponse = z.infer<typeof offerResponse>

// 32 random bytes as base64url - anything else is not one of ours and never reaches the database
export const statusTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/)
